import {Component} from '@angular/core';

@Component({
    selector: 'app-vcc-report',
    templateUrl: './vcc-report.component.html',
    standalone: false
})
export class VccReportComponent {
}
